import { useAuth0 } from "@auth0/auth0-react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@mui/material/IconButton";
import OpenInNewOutlinedIcon from "@material-ui/icons/OpenInNewOutlined";
import downloadImg, { ReactComponent as Download } from "assets/icons/DownloadIcon.svg";
import shareImg from "assets/icons/Share.svg";
import deleteImg from "assets/icons/Trush.svg";
import eyeImg from "assets/icons/eyeIcon.svg";
import moment from "moment";
import React, { memo, useEffect, useState } from "react";
import thousands from "thousands";
import { DateFormetContext } from "../../../../app/App.js";
import { MyCheckbox } from "../../../../components";
import { downloadFile, uploadFile } from "../../../Auth/Presigned";

import Stack from "@mui/material/Stack";
import {
  Document,
  Image,
  Link,
  Note,
  PDFDownloadLink,
  Page,
  StyleSheet,
  Svg,
  Text,
  View,
  pdf,
  usePDF,
} from "@react-pdf/renderer";
import { useSelector } from "react-redux";

import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat.js";
import { CheckFloatValue } from "../../../../utils/functions";
import "./theme.scss";
const DocumentsData = (props) => {
  const {
    row,
    modifyRowData,
    onCheckboxChange,
    check,
    onReversalClick,
    setDrawerData,
    setOpenModal,
    filters,
    downloadPDF,
    viewDocument,
    documentData,
    sharePDF,
    fileData,
    file,
    documentHandler,
    viewDocumentHandler,
    downloadFileHandler,
    deleteDocumentHandler,
    checkAll
  } = props;
  // const dateFormet = useContext(DateFormetContext);
  const dateFormet = React.useContext(DateFormetContext);
  const { getAccessTokenSilently } = useAuth0();
  const [reversalActionTypes, setReversalActionTypes] = useState(false);

  // const LogoImage = useSelector((state) => state.homeReducer.headerLogo);

  const [logoImage, setLogoImage] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLogoImage(localStorage?.getItem("Base64"));
    // Image = localStorage?.getItem("Base64");
  }, []);

  let totalAmount = 0;
  for (let i = 0; i < row?.transaction.length; i++) {
    if (row?.transaction) {
      totalAmount += row?.transaction[i].total_amount;
    }
  }

  let totalAmountPaid = 0;
  for (let i = 0; i < row?.transaction.length; i++) {
    if (row?.transaction) {
      if (row?.transaction?.[i]?.total_paid) {
        if (row?.transaction?.[i]?.total_paid === null) totalAmountPaid += 0;
        else {
          totalAmountPaid += row?.transaction?.[i]?.total_paid;
        }
      } else {
        totalAmountPaid += 0;
      }
    }
  }

  let totalAmount_due = 0;
  for (let i = 0; i < row?.transaction.length; i++) {
    if (row?.transaction) {
      if (row?.transaction?.[i]?.amount_due) {
        if (row?.transaction?.[i]?.amount_due === null) totalAmount_due += 0;
        else {
          totalAmount_due += row?.transaction?.[i]?.amount_due;
        }
      } else {
        totalAmount_due += 0;
      }
    }
  }

  let totalElgAmount = 0;
  for (let i = 0; i < row?.transaction.length; i++) {
    if (row?.transaction) {
      totalElgAmount += row?.transaction[i].eligible_amount;
    }
  }
  let totalContAmount = 0;
  for (let i = 0; i < row?.transaction.length; i++) {
    if (row?.transaction) {
      totalContAmount += row?.transaction[i].contribution_amount;
    }
  }

  // const printDocument = () => {
  //   alert("print hanlde");
  //   const input = document.getElementById("divToPrint");
  //   console.log(input, "hello input");
  //   html2canvas(input).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF();
  //     pdf.addImage(imgData, "JPEG", 0, 0);
  //     // pdf.output('dataurlnewwindow');
  //     pdf.save("download.pdf");
  //   });
  // };

  const getCommaSeperatedValue = (num) => {
    return CheckFloatValue(num)
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const handleView = () => {
    // console.log("view", row);
    viewDocument(row?.type);
    documentData(row);
  };

  const handelDownload = () => {
    // console.log("downloaddddddd");
    documentData(row);
    downloadPDF(row?.type);
  };

  const handelShare = () => {
    // console.log("share");
    documentData(row);
    sharePDF(row?.type);
  };








  const receiptPayments = [];
  const a = row?.transaction?.map((item, i) => {
    let payment = item?.payment?.map((i) => {
      receiptPayments.push(i);
    });
    // return ;
  });

  const length = 3500;

  const commentInvoice = row?.transaction
    ?.map((item) => {
      return item?.comment_invoice?.note &&
        item?.comment_invoice?.visible === true
        ? item?.comment_invoice?.note
        : " ";
    })[0]
    ?.substring(0, length);

  const commentReceipt = row?.transaction
    ?.map((item) => {
      return item?.comment_receipt?.note &&
        item?.comment_receipt?.visible === true
        ? item?.comment_receipt?.note
        : " ";
    })[0]
    ?.substring(0, length);
  let address = {};
  if (row?.account_details?.addresses) {
    for (var i = 0; i < row?.account_details?.addresses?.length; i++) {
      if (row?.account_details?.addresses[i]?.billing) {
        address = {
          city: row.account_details.addresses[i].city,
          state: row.account_details.addresses[i].state,
          zip_code: row.account_details.addresses[i].zip_code,
          formattedAddress: `${
            row.account_details.addresses[i].location?.formattedAddress?.split(
              ","
            )[0]
          } ${
            row.account_details.addresses[i].addressLine2
              ? row.account_details.addresses[i].addressLine2
              : ""
          } `,
        };
      }
    }
  }

  console.log(
    "address",
    address,
    row?.account_details,
    row?.account_details?.addresses
  );
  const receiptPdfStyles = StyleSheet.create({
    logo: {
      width: "130pt",
      height: "50pt",
    },
    docMain: {
      padding: "30pt",
    },
    orgName: {
      fontWeight: "600",
      fontSize: "12pt",
    },
    docoHead: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "20px",
    },
    docOrgDetails: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    docOrgDetailsAddress: {
      marginTop: "10px",
      fontSize: "10pt",
      fontWeight: "300",
    },
    docOrgDetailsPhone: {
      marginTop: "5px",
      fontSize: "10pt",
      fontWeight: "300",
    },
    docBody: {
      marginTop: "20px",
    },
    docoBodyHeading: {
      marginBottom: "10px",
    },
    docoBodyHeadingHead: {
      borderBottom: "2px solid #4f4f4f",
      paddingBottom: "15px",
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "row",
      marginBottom: "15px",
    },
    docoBodyHeadingHeadH1: {
      fontSize: "15pt",
      fontWeight: "800",
    },
    docoBodyHeadingHeadP: {
      fontSize: "10pt",
      fontWeight: "700",
    },
    docoBodySubHead: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    docoBodySubHeadName: {
      fontSize: "10px",
    },
    docoBodySubHeadDate: {
      fontSize: "10px",
    },
    docoBodySubHeadAddresses: {
      display: "flex",
      flexDirection: "column",
      marginTop: "2pt",
    },
    docoBodySubHeadcity: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    docoBodySubHeadZip: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    docoBodySubHeadPhone: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    outStandingText: { fontSize: "12pt" },
    dateDetails: {
      paddingBottom: "5px",
      display: "flex",
      flexDirection: "column",
    },
    outStandingMain: {
      display: "flex",
      margin: "15px 0px",
    },
    table: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#f7f7f7",
    },
    table2: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#f7f7f7",
      marginTop: "15pt",
    },
    tableHeading: {
      padding: "10pt 5pt",
      backgroundColor: "#4f4f4f",
      color: "white",
      display: "flex",
    },
    tableHeadingText: {
      fontSize: "12pt",
    },
    HeaderRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      fontWeight: "800",
      flexDirection: "row",
    },
    HeaderRow2: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      fontWeight: "800",
      flexDirection: "row",
    },
    BodyRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      flexDirection: "row",
      borderTop: "2px solid white",
    },
    DateCol: {
      width: "300px",
    },
    ChargeDetailCol: {
      width: "400px",
    },
    AmountCol: {
      width: "300px",
    },
    totalRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "12pt",
      padding: "10pt 5pt",
      fontWeight: "900",
      flexDirection: "row",
      marginTop: "40px",
      padding: "10pt 5pt",
      backgroundColor: "#f7f7f7",
    },
    footer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: "52pt",
      padding: "15pt 0pt",
      borderTop: "2px solid black",
      fontSize: "10pt",
    },
    footerBorder: {
      display: "flex",
      flexDirection: "row",
      padding: "5px 0pt",
      backgroundColor: "#4f4f4f",
    },
    DateCol2: {
      width: "200px",
    },
    methodCol2: {
      width: "200px",
    },
    AmountCol2: {
      width: "200px",
    },
    starCol2: {
      width: "200px",
    },
    note: {
      fontSize: "10pt",
      marginTop: "15pt",
      display: "flex",
    },
    sign: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      fontSize: "10pt",
      backgroundColor: "red",
    },
  });
  const styles = StyleSheet.create({
    page: {
      height: "60vh",
    },
    logo: {
      width: "130pt",
      height: "50pt",
    },
    docMain: {
      padding: "30pt",
    },
    orgName: {
      fontWeight: "600",
      fontSize: "12pt",
    },
    docoHead: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "20px",
    },
    docOrgDetails: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    docOrgDetailsAddress: {
      marginTop: "10px",
      fontSize: "10pt",
      fontWeight: "300",
    },
    docOrgDetailsPhone: {
      marginTop: "5px",
      fontSize: "10pt",
      fontWeight: "300",
    },
    docBody: {
      marginTop: "20px",
    },
    docoBodyHeading: {
      marginBottom: "10px",
    },
    docoBodyHeadingHead: {
      borderBottom: "2px solid #4f4f4f",
      paddingBottom: "15px",
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "row",
      marginBottom: "15px",
    },
    docoBodyHeadingHeadH1: {
      fontSize: "15pt",
      fontWeight: "800",
    },
    docoBodyHeadingHeadP: {
      fontSize: "10pt",
      fontWeight: "700",
    },
    docoBodySubHead: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    docoBodySubHeadName: {
      fontSize: "10px",
    },
    docoBodySubHeadDate: {
      fontSize: "10px",
    },
    docoBodySubHeadAddresses: {
      display: "flex",
      flexDirection: "column",
      marginTop: "2pt",
    },
    docoBodySubHeadcity: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    docoBodySubHeadZip: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    docoBodySubHeadPhone: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    outStandingText: { fontSize: "12pt" },
    dateDetails: {
      paddingBottom: "5px",
      display: "flex",
      flexDirection: "column",
    },
    outStandingMain: {
      display: "flex",
      margin: "15px 0px",
    },
    table: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#f7f7f7",
    },
    tableHeading: {
      padding: "10pt 5pt",
      backgroundColor: "#4f4f4f",
      color: "white",
      display: "flex",
    },
    tableHeadingText: {
      fontSize: "12pt",
    },
    HeaderRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      fontWeight: "800",
      flexDirection: "row",
    },
    BodyRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      flexDirection: "row",
      borderTop: "2px solid white",
    },
    DateCol: {
      width: "150px",
    },
    ChargeDetailCol: {
      width: "180px",
    },
    AmountCol: {
      width: "150px",
    },
    AmountPaidCol: {
      width: "150px",
    },
    AmountDueCol: {
      width: "150px",
    },
    totalRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "12pt",
      padding: "10pt 5pt",
      fontWeight: "900",
      flexDirection: "row",
      marginTop: "40px",
      padding: "10pt 5pt",
      backgroundColor: "#f7f7f7",
    },
    footer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: "52pt",
      padding: "15pt 0pt",
      borderTop: "2px solid black",
      fontSize: "10pt",
    },
    footerBorder: {
      display: "flex",
      flexDirection: "row",
      padding: "5px 0pt",
      backgroundColor: "#4f4f4f",
    },
  });

  const TaxStatementPdf =
    row?.type == "tax_statement" ? (
      <Document id="divToPrint">
        <Page style={styles.docMain}>
          <View>
            <View style={styles.docoHead}>
              <View style={styles.docOrgDetails}>
                <View>
                  <Text style={styles.orgName}>
                    {row?.organization?.orgName}
                  </Text>
                  <Text style={styles.docOrgDetailsAddress}>
                    {row?.organization?.contactInfo?.address}
                  </Text>
                  <Text style={styles.docOrgDetailsPhone}>
                    {row.organization.contactInfo.phone}
                  </Text>
                </View>
                <View styles={styles.image}>
                  <Image src={logoImage} style={styles.logo} />
                </View>
              </View>
            </View>
            <View style={styles.docBody}>
              <View style={styles.docoBodyHeading}>
                <View style={styles.docoBodyHeadingHead}>
                  <Text style={styles.docoBodyHeadingHeadH1}>
                    Statement {row?.tax_id}
                  </Text>
                  {/* <Text style={styles.docoBodyHeadingHeadP}>
                    Tax ID {row?.tax_id}
                  </Text> */}
                </View>
                <View style={styles.dateDetails}>
                  <View style={styles.docoBodySubHead}>
                    <Text style={styles.docoBodySubHeadName}>
                      To: {row?.name}{" "}
                    </Text>
                    <Text style={styles.docoBodySubHeadDate}>
                      {moment(row?.createdAt).utcOffset("+0100").format("LL")}
                    </Text>
                  </View>
                  {/* <View style={styles.docoBodySubHead}>
                    <Text style={styles.docoBodySubHeadName}>
                      Balance: $ {thousands((+totalAmount_due).toFixed(2))}{" "}
                    </Text>
                  </View> */}
                  <View style={styles.docoBodySubHeadAddresses}>
                    <Text style={styles.docoBodySubHeadcity}>
                      {address?.formattedAddress}

                      {/* {row?.account_details?.city}
                      {row?.account_details?.city && row?.account_details?.state
                        ? ","
                        : ""}{" "}
                      {row?.account_details?.state} */}
                    </Text>
                    <Text style={styles.docoBodySubHeadcity}>
                      {address?.city}, {address?.state} {address?.zip_code}
                      {/* {row?.account_details?.city}
                      {row?.account_details?.city && row?.account_details?.state
                        ? ","
                        : ""}{" "}
                      {row?.account_details?.state} */}
                    </Text>
                    {/* <Text style={styles.docoBodySubHeadZip}>
                      {row?.account_details?.zip_code}
                    </Text> */}
                    <Text style={styles.docoBodySubHeadPhone}>
                      {" "}
                      {row?.account_details?.admin_contact}
                    </Text>
                  </View>
                </View>
              </View>
              <View style={styles.outStandingMain}>
                <Text style={styles.outStandingText}>
                  Outstanding balance: ${" "}
                  {thousands((+totalAmount_due).toFixed(2))} as of{" "}
                  {moment(row?.date.end).utcOffset("+0100").format("LL")}
                </Text>
              </View>
              <View style={styles.table}>
                <View style={styles.tableHeading}>
                  <Text style={styles.tableHeadingText}>Payments</Text>
                </View>
                <View style={styles.HeaderRow}>
                  <Text style={styles.DateCol}>DATE</Text>
                  <Text style={styles.ChargeDetailCol}>CHARGE DETAILS</Text>
                  <Text style={styles.AmountCol}>AMOUNT</Text>
                  <Text style={styles.AmountPaidCol}>AMOUNT PAID</Text>
                  <Text style={styles.AmountDueCol}>AMOUNT DUE</Text>
                </View>
                {row?.transaction?.map((item, i) => {
                  return (
                    <View style={styles.BodyRow}>
                      <Text style={styles.DateCol}>
                        {moment(item?.date)
                          .utcOffset("+0100")
                          .format(dateFormet)}
                      </Text>
                      <Text style={styles.ChargeDetailCol}>
                        {item?.details?.Ledger?.name
                          ? item?.details?.Ledger?.name
                          : ""}
                        {item?.details?.SubLedger?.name ? "\n" : ""}
                        {item?.details?.SubLedger?.name
                          ? item?.details?.SubLedger?.name
                          : ""}

                        {item?.visible ? "\n" : ""}
                        {item?.visible ? item?.note : ""}
                      </Text>
                      <Text style={styles.AmountCol}>
                        {/* {getCommaSeperatedValue(item?.total_amount)} */}${" "}
                        {item?.total_amount
                          ? thousands((+item?.total_amount).toFixed(2))
                          : "0.00"}
                      </Text>
                      <Text style={styles.AmountPaidCol}>
                        {/* {getCommaSeperatedValue(item?.total_paid)} */}${" "}
                        {item?.total_paid
                          ? thousands((+item?.total_paid).toFixed(2))
                          : "0.00"}
                      </Text>
                      <Text style={styles.AmountDueCol}>
                        {/* {getCommaSeperatedValue(item?.amount_due)} */}${" "}
                        {item?.amount_due
                          ? thousands((+item?.amount_due).toFixed(2))
                          : "0.00"}
                      </Text>
                    </View>
                  );
                })}
              </View>
              <View style={styles.totalRow}>
                <Text style={styles.DateCol}>Total</Text>
                <Text style={styles.ChargeDetailCol}> </Text>
                <Text style={styles.AmountCol}>
                  {" "}
                  $ {thousands((+totalAmount).toFixed(2))}
                </Text>
                <Text style={styles.AmountCol}>
                  {" "}
                  $ {thousands((+totalAmountPaid).toFixed(2))}
                </Text>
                <Text style={styles.AmountCol}>
                  {" "}
                  $ {thousands((+totalAmount_due).toFixed(2))}
                </Text>
              </View>

              <View style={styles.footer}>
                {/* <View style={styles.footerBorder}></View> */}
                <Text className="m-0">
                  Page 1 of 1 | Statement {row?.tax_id} | Created{" "}
                  {moment(row?.createdAt)
                    .utcOffset("+0100")
                    .format("LL h:mm A")}
                </Text>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    ) : (
      ""
    );
  const TaxReportStyles = StyleSheet.create({
    page: {
      height: "60vh",
    },
    logo: {
      width: "130pt",
      height: "50pt",
    },
    docMain: {
      padding: "30pt",
    },
    orgName: {
      fontWeight: "600",
      fontSize: "12pt",
    },
    docoHead: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "20px",
    },
    docOrgDetails: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    docOrgDetailsAddress: {
      marginTop: "10px",
      fontSize: "10pt",
      fontWeight: "300",
    },
    docOrgDetailsPhone: {
      marginTop: "5px",
      fontSize: "10pt",
      fontWeight: "300",
    },
    docBody: {
      marginTop: "20px",
    },
    docoBodyHeading: {
      marginBottom: "10px",
    },
    docoBodyHeadingHead: {
      borderBottom: "2px solid #4f4f4f",
      paddingBottom: "15px",
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "row",
      marginBottom: "15px",
    },
    docoBodyHeadingHeadH1: {
      fontSize: "15pt",
      fontWeight: "800",
    },
    docoBodyHeadingHeadP: {
      fontSize: "10pt",
      fontWeight: "700",
    },
    docoBodySubHead: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    docoBodySubHeadName: {
      fontSize: "10px",
    },
    docoBodySubHeadDate: {
      fontSize: "10px",
    },
    docoBodySubHeadAddresses: {
      display: "flex",
      flexDirection: "column",
      marginTop: "2pt",
    },
    docoBodySubHeadcity: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    docoBodySubHeadZip: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    docoBodySubHeadPhone: {
      fontSize: "10pt",
      marginBottom: "2pt",
    },
    outStandingText: { fontSize: "12pt" },
    dateDetails: {
      paddingBottom: "5px",
      display: "flex",
      flexDirection: "column",
    },
    outStandingMain: {
      display: "flex",
      margin: "15px 0px",
    },
    table: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#f7f7f7",
    },
    tableHeading: {
      padding: "10pt 5pt",
      backgroundColor: "#4f4f4f",
      color: "white",
      display: "flex",
    },
    tableHeadingText: {
      fontSize: "12pt",
    },
    HeaderRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      fontWeight: "800",
      flexDirection: "row",
    },
    BodyRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "10pt",
      padding: "10pt 5pt",
      flexDirection: "row",
      borderTop: "2px solid white",
    },
    DateCol: {
      width: "150px",
    },
    ChargeDetailCol: {
      width: "180px",
    },
    totalRowText: {
      width: "180px",
    },
    totalRowAmount: {
      width: "150px",
    },
    AmountCol: {
      width: "150px",
    },
    AmountPaidCol: {
      width: "150px",
    },
    AmountDueCol: {
      width: "150px",
    },
    totalRow: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "12pt",
      padding: "10pt 5pt",
      fontWeight: "900",
      flexDirection: "row",
      marginTop: "40px",
      padding: "10pt 5pt",
      backgroundColor: "#f7f7f7",
    },
    footer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: "52pt",
      padding: "15pt 0pt",
      borderTop: "2px solid black",
      fontSize: "10pt",
    },
    footerBorder: {
      display: "flex",
      flexDirection: "row",
      padding: "5px 0pt",
      backgroundColor: "#4f4f4f",
    },
  });

  const TaxReportPdf =
    row?.type == "tax_report" ? (
      <Document id="divToPrint">
        <Page style={TaxReportStyles.docMain}>
          <View>
            <View style={TaxReportStyles.docoHead}>
              <View style={TaxReportStyles.docOrgDetails}>
                <View>
                  <Text style={TaxReportStyles.orgName}>
                    {row?.organization?.orgName}
                  </Text>
                  <Text style={TaxReportStyles.docOrgDetailsAddress}>
                    {row?.organization?.contactInfo?.address}
                  </Text>
                  <Text style={TaxReportStyles.docOrgDetailsPhone}>
                    {row.organization.contactInfo.phone}
                  </Text>
                </View>
                <View>
                  <Image src={logoImage} style={TaxReportStyles.logo} />
                </View>
              </View>
            </View>
            <View style={TaxReportStyles.docBody}>
              <View style={TaxReportStyles.docoBodyHeading}>
                <View style={TaxReportStyles.docoBodyHeadingHead}>
                  <Text style={TaxReportStyles.docoBodyHeadingHeadH1}>
                    Tax Report {row?.tax_id}
                  </Text>
                  {/* <Text style={TaxReportStyles.docoBodyHeadingHeadP}>
                    Tax ID {row?.tax_id}
                  </Text> */}
                </View>
                <View style={TaxReportStyles.dateDetails}>
                  <View style={TaxReportStyles.docoBodySubHead}>
                    <Text style={TaxReportStyles.docoBodySubHeadName}>
                      To: {row?.name}{" "}
                    </Text>
                    <Text style={TaxReportStyles.docoBodySubHeadDate}>
                      {moment(row?.createdAt).utcOffset("+0100").format("LL")}
                    </Text>
                  </View>
                  {/* <View style={styles.docoBodySubHead}>
                    <Text style={styles.docoBodySubHeadName}>
                      Balance: {row?.account_details?.balance ?? "0"}{" "}
                    </Text>
                  </View> */}
                  <View style={TaxReportStyles.docoBodySubHeadAddresses}>
                    <Text style={styles.docoBodySubHeadcity}>
                      {address?.formattedAddress}
                    </Text>
                    <Text style={styles.docoBodySubHeadZip}>
                      {address?.city}, {address?.state} {address?.zip_code}
                    </Text>
                    <Text style={TaxReportStyles.docoBodySubHeadPhone}>
                      {" "}
                      {row?.account_details?.admin_contact}
                    </Text>
                  </View>
                </View>
              </View>
              <View style={TaxReportStyles.outStandingMain}>
                <Text style={TaxReportStyles.outStandingText}>
                  Payment made from{" "}
                  {moment(row?.date.start).utcOffset("+0100").format("LL")}{" "}
                  to:&nbsp;
                  {moment(row?.date.end).utcOffset("+0100").format("LL")}
                </Text>
              </View>
              <View style={TaxReportStyles.table}>
                <View style={TaxReportStyles.tableHeading}>
                  <Text style={TaxReportStyles.tableHeadingText}>Payments</Text>
                </View>
                <View style={TaxReportStyles.HeaderRow}>
                  <Text style={TaxReportStyles.ChargeDetailCol}>
                    CHARGE DETAILS
                  </Text>
                  <Text style={TaxReportStyles.AmountCol}>ELIGIBLE AMOUNT</Text>
                  <Text style={TaxReportStyles.AmountDueCol}>
                    CONTRIBUTION AMOUNT
                  </Text>
                </View>
                {row?.transaction?.map((item, i) => {
                  return (
                    <View style={TaxReportStyles.BodyRow}>
                      <Text style={TaxReportStyles.ChargeDetailCol}>
                        {item?.Ledger?.name ?? ""}
                      </Text>
                      <Text style={TaxReportStyles.AmountCol}>
                        {/* ${getCommaSeperatedValue(item?.eligible_amount)} */}
                        ${" "}
                        {item?.eligible_amount
                          ? thousands((+item?.eligible_amount).toFixed(2))
                          : "0.00"}
                      </Text>
                      <Text style={TaxReportStyles.AmountPaidCol}>
                        {/* ${getCommaSeperatedValue(item?.contribution_amount)} */}
                        ${" "}
                        {item?.contribution_amount
                          ? thousands((+item?.contribution_amount).toFixed(2))
                          : "0.00"}
                      </Text>
                    </View>
                  );
                })}
              </View>
              <View style={TaxReportStyles.totalRow}>
                <Text style={TaxReportStyles.totalRowText}>Total</Text>
                <Text style={TaxReportStyles.totalRowAmount}>
                  {" "}
                  {/* ${getCommaSeperatedValue(totalElgAmount)} */}${" "}
                  {totalElgAmount
                    ? thousands((+totalElgAmount).toFixed(2))
                    : "0.00"}
                </Text>
                <Text style={TaxReportStyles.totalRowAmount}>
                  {" "}
                  {/* ${getCommaSeperatedValue(totalContAmount)} */}${" "}
                  {totalContAmount
                    ? thousands((+totalContAmount).toFixed(2))
                    : "0.00"}
                </Text>
              </View>

              <View style={TaxReportStyles.footer}>
                {/* <View style={TaxReportStyles.footerBorder}></View> */}
                <Text className="m-0">
                  Page 1 of 1 | Tax Report {row?.tax_id} | Created{" "}
                  {moment(row?.createdAt)
                    .utcOffset("+0100")
                    .format("MMMM Do, YYYY h:mm A")}
                </Text>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    ) : (
      ""
    );
  const ReceiptPdf =
    row?.type == "receipt" ? (
      <Document>
        <Page style={receiptPdfStyles.docMain}>
          <View>
            <View style={receiptPdfStyles.docoHead}>
              <View style={receiptPdfStyles.docOrgDetails}>
                <View>
                  <Text style={receiptPdfStyles.orgName}>
                    {row?.organization?.orgName}
                  </Text>
                  <Text style={receiptPdfStyles.docOrgDetailsAddress}>
                    {row?.organization?.contactInfo?.address}
                  </Text>
                  <Text style={receiptPdfStyles.docOrgDetailsPhone}>
                    {row.organization.contactInfo.phone}
                  </Text>
                </View>
                <View>
                  <Image src={logoImage} style={receiptPdfStyles.logo} />
                </View>
              </View>
            </View>
            <View style={receiptPdfStyles.docBody}>
              <View style={receiptPdfStyles.docoBodyHeading}>
                <View style={receiptPdfStyles.docoBodyHeadingHead}>
                  <Text style={receiptPdfStyles.docoBodyHeadingHeadH1}>
                    Receipt {row?.tax_id}
                  </Text>
                  {/* <Text style={receiptPdfStyles.docoBodyHeadingHeadP}>
                    Tax ID {row?.tax_id}
                  </Text> */}
                </View>
                <View style={receiptPdfStyles.dateDetails}>
                  <View style={receiptPdfStyles.docoBodySubHead}>
                    <Text style={receiptPdfStyles.docoBodySubHeadName}>
                      To: {row?.name}
                    </Text>
                    <Text style={receiptPdfStyles.docoBodySubHeadDate}>
                      {moment(row?.createdAt)
                        .utcOffset("+0100")
                        .format("MMMM Do, YYYY")}
                    </Text>
                  </View>
                  {/* <View style={styles.docoBodySubHead}>
                    <Text style={styles.docoBodySubHeadName}>
                      Balance: {row?.account_details?.balance ?? "0"}{" "}
                    </Text>
                  </View> */}
                  <View style={receiptPdfStyles.docoBodySubHeadAddresses}>
                    <Text style={styles.docoBodySubHeadcity}>
                      {address?.formattedAddress}

                      {/* {row?.account_details?.city}
                      {row?.account_details?.city && row?.account_details?.state
                        ? ","
                        : ""}{" "}
                      {row?.account_details?.state} */}
                    </Text>
                    <Text style={styles.docoBodySubHeadcity}>
                      {address?.city}, {address?.state} {address?.zip_code}
                      {/* {row?.account_details?.city}
                      {row?.account_details?.city && row?.account_details?.state
                        ? ","
                        : ""}{" "}
                      {row?.account_details?.state} */}
                    </Text>
                    <Text style={receiptPdfStyles.docoBodySubHeadPhone}>
                      {" "}
                      {row?.account_details?.admin_contact}
                    </Text>
                  </View>
                </View>
              </View>
              {/* <View style={receiptPdfStyles.outStandingMain}>
                <Text style={receiptPdfStyles.outStandingText}>
                  Outstanding as of{" "}
                  {moment(row?.date.start)
                    .utcOffset("+0100")
                    .format("MMMM Do, YYYY")}
                </Text>
              </View> */}
              <View style={receiptPdfStyles.table}>
                <View style={receiptPdfStyles.tableHeading}>
                  <Text style={receiptPdfStyles.tableHeadingText}>Charges</Text>
                </View>
                <View style={receiptPdfStyles.HeaderRow}>
                  <Text style={receiptPdfStyles.DateCol}>DATE</Text>
                  <Text style={receiptPdfStyles.ChargeDetailCol}>
                    CHARGE DETAILS
                  </Text>
                  <Text style={receiptPdfStyles.AmountCol}>AMOUNT</Text>
                </View>
                {row?.transaction?.map((item, i) => {
                  return (
                    <View style={receiptPdfStyles.BodyRow}>
                      <Text style={receiptPdfStyles.DateCol}>
                        {moment(item?.due_date)
                          .utcOffset("+0100")
                          .format(dateFormet)}
                      </Text>
                      <Text style={receiptPdfStyles.ChargeDetailCol}>
                        {item?.Ledger?.name ? item?.Ledger?.name : ""}
                      </Text>
                      <Text style={receiptPdfStyles.AmountCol}>
                        {/* {getCommaSeperatedValue(item?.total_amount)} */}${" "}
                        {item?.total_amount
                          ? thousands((+item?.total_amount).toFixed(2))
                          : "0.00"}
                      </Text>
                    </View>
                  );
                })}
              </View>

              <View style={receiptPdfStyles.table2}>
                <View style={receiptPdfStyles.tableHeading}>
                  <Text style={receiptPdfStyles.tableHeadingText}>
                    Payment Details
                  </Text>
                </View>
                <View style={receiptPdfStyles.HeaderRow2}>
                  <Text style={receiptPdfStyles.DateCol2}>DATE</Text>
                  <Text style={receiptPdfStyles.methodCol2}>
                    PAYMENT METHOD
                  </Text>
                  <Text style={receiptPdfStyles.starCol2}>DETAILS</Text>
                  <Text style={receiptPdfStyles.AmountCol2}>AMOUNT</Text>
                </View>
                {receiptPayments?.map((item, i) => {
                  return (
                    <View style={receiptPdfStyles.BodyRow}>
                      <Text style={receiptPdfStyles.DateCol2}>
                        {moment(item?.date)
                          .utcOffset("+0100")
                          .format(dateFormet)}
                      </Text>
                      <Text style={receiptPdfStyles.methodCol2}>
                        {item?.method ? item?.method : ""}
                      </Text>
                      <Text style={receiptPdfStyles.starCol2}>*******</Text>
                      <Text style={receiptPdfStyles.AmountCol2}>
                        {/* {getCommaSeperatedValue(item?.amount)} */}${" "}
                        {item?.amount
                          ? thousands((+item?.amount).toFixed(2))
                          : "0.00"}
                      </Text>
                    </View>
                  );
                })}
              </View>

              <View>
                <Text style={receiptPdfStyles.note}>{commentReceipt}</Text>
              </View>

              <View style={receiptPdfStyles.footer}>
                <Text className="m-0">
                  Page 1 of 1 | Receipt {row?.tax_id} | Created{" "}
                  {moment(row?.createdAt)
                    .utcOffset("+0100")
                    .format("MMMM Do, YYYY h:mm A")}
                </Text>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    ) : (
      <></>
    );

  const invoicePdf =
    row?.type == "invoice" ? (
      <Document>
        <Page style={styles.docMain}>
          <View>
            <View style={styles.docoHead}>
              <View style={styles.docOrgDetails}>
                <View>
                  <Text style={styles.orgName}>
                    {row?.organization?.orgName}
                  </Text>
                  <Text style={styles.docOrgDetailsAddress}>
                    {row?.organization?.contactInfo?.address}
                  </Text>
                  <Text style={styles.docOrgDetailsPhone}>
                    {row.organization.contactInfo.phone}
                  </Text>
                </View>
                <View>
                  <Image src={logoImage} style={styles.logo} />
                </View>
              </View>
            </View>
            <View style={styles.docBody}>
              <View style={styles.docoBodyHeading}>
                <View style={styles.docoBodyHeadingHead}>
                  <Text style={styles.docoBodyHeadingHeadH1}>
                    Invoice {row?.tax_id}
                  </Text>
                  {/* <Text style={styles.docoBodyHeadingHeadP}>
                    Tax ID {row?.tax_id}
                  </Text> */}
                </View>
                <View style={styles.dateDetails}>
                  <View style={styles.docoBodySubHead}>
                    <Text style={styles.docoBodySubHeadName}>
                      To: {row?.name}{" "}
                    </Text>
                    <Text style={styles.docoBodySubHeadDate}>
                      {moment(row?.createdAt)
                        .utcOffset("+0100")
                        .format("MMMM Do, YYYY")}
                    </Text>
                  </View>
                  {/* <View style={styles.docoBodySubHead}>
                    <Text style={styles.docoBodySubHeadName}>
                      Balance: {row?.account_details?.balance ?? "0"}{" "}
                    </Text>
                  </View> */}
                  <View style={styles.docoBodySubHeadAddresses}>
                    <Text style={styles.docoBodySubHeadcity}>
                      {address?.formattedAddress}

                      {/* {row?.account_details?.city}
                      {row?.account_details?.city && row?.account_details?.state
                        ? ","
                        : ""}{" "}
                      {row?.account_details?.state} */}
                    </Text>
                    <Text style={styles.docoBodySubHeadcity}>
                      {address?.city}, {address?.state} {address?.zip_code}
                      {/* {row?.account_details?.city}
                      {row?.account_details?.city && row?.account_details?.state
                        ? ","
                        : ""}{" "}
                      {row?.account_details?.state} */}
                    </Text>
                    <Text style={styles.docoBodySubHeadPhone}>
                      {" "}
                      {row?.account_details?.admin_contact}
                    </Text>
                  </View>
                </View>
              </View>
              <View style={styles.table}>
                <View style={styles.tableHeading}>
                  <Text style={styles.tableHeadingText}>Charges</Text>
                </View>
                <View style={styles.HeaderRow}>
                  <Text style={styles.DateCol}>DATE</Text>
                  <Text style={styles.ChargeDetailCol}>CHARGE DETAILS</Text>
                  <Text style={styles.AmountCol}>AMOUNT</Text>
                </View>
                {row?.transaction?.map((item, i) => {
                  return (
                    <View style={styles.BodyRow}>
                      <Text style={styles.DateCol}>
                        {moment(item?.date)
                          .utcOffset("+0100")
                          .format(dateFormet)}
                      </Text>
                      <Text style={styles.ChargeDetailCol}>
                        {item?.Ledger?.name ?? ""}
                      </Text>
                      <Text style={styles.AmountCol}>
                        {/* {getCommaSeperatedValue(item?.total_amount)} */}${" "}
                        {item?.total_amount
                          ? thousands((+item?.total_amount).toFixed(2))
                          : "0.00"}
                      </Text>
                    </View>
                  );
                })}
              </View>
              <View style={styles.totalRow}>
                <Text style={styles.totalRowText}>Total Due</Text>
                <Text style={styles.AmountCol}>{""}</Text>
                <Text style={styles.AmountCol}>
                  {" "}
                  {/* ${getCommaSeperatedValue(totalAmount)} */}${" "}
                  {totalAmount ? thousands((+totalAmount).toFixed(2)) : "0.00"}
                </Text>
              </View>

              <View>
                <Text style={receiptPdfStyles.note}>{commentInvoice}</Text>
              </View>

              <View style={styles.footer}>
                {/* <View style={styles.footerBorder}></View> */}
                <Text className="m-0">
                  Page 1 of 1 | Invoice {row?.tax_id} | Created{" "}
                  {moment(row?.createdAt)
                    .utcOffset("+0100")
                    .format("MMMM Do, YYYY h:mm A")}
                </Text>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    ) : (
      ""
    );

  const [convertedTaxReport, setConvertedTaxReport] = useState(
    new File([<TaxReportPdf />], "invoicePDF", { type: "application/pdf" })
  );
  const [convertedTaxStatementPdf, setConvertedTaxStatementPdf] = useState(
    new File([<TaxReportPdf />], "Statement", { type: "application/pdf" })
  );
  const [convertedReceiptPdf, setConvertedReceiptPdf] = useState(
    new File([<TaxReportPdf />], "Statement", { type: "application/pdf" })
  );
  const [convertedinvoicePdf, setConvertedinvoicePdf] = useState(
    new File([<TaxReportPdf />], "Statement", { type: "application/pdf" })
  );

  const [instance, updateInstance] = usePDF({
    document:
      row?.type == "tax_report" ? (
        <convertedTaxReport />
      ) : row?.type == "receipt" ? (
        <convertedReceiptPdf />
      ) : row?.type == "tax_statement" ? (
        <convertedTaxStatementPdf />
      ) : (
        <convertedinvoicePdf />
      ),
  });

  const shareMy = async () => {
    setLoading(true);
    let fileToShare =
      row?.type == "tax_report"
        ? convertedTaxReport
        : row?.type == "receipt"
        ? convertedReceiptPdf
        : row?.type == "tax_statement"
        ? convertedTaxStatementPdf
        : convertedinvoicePdf;
    const token = await getAccessTokenSilently();

    // alert("print hanlde");
    // const input = document.getElementById("divToPrint");
    // console.log(input, "hello input");
    // html2canvas(input).then((canvas) => {
    //   const imgData = canvas.toDataURL("image/png");
    //   const pdf = new jsPDF();
    //   pdf.addImage(imgData, "JPEG", 0, 0);
    //   // pdf.output('dataurlnewwindow');
    //   pdf.save("download.pdf");
    // });

    console.log(fileToShare, "fileToShare");

    var reader = new FileReader();
    reader.readAsDataURL(instance?.blob);
    reader.onloadend = async () => {
      var base64data = reader.result;
      var splitedImgData = base64data.split(",")[1];
      var binary_string = window.atob(splitedImgData);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }

      console.log(base64data, "base64data");
      if (base64data) {
        let newURL = await uploadFile(
          bytes.buffer,
          fileToShare,
          token,
          "download"
        );
        let downloadLink = await downloadFile(`${newURL.fileName}`, token);
        let downloadURL = downloadLink.link;
        if (downloadURL) {
          setLoading(false);
        }
        window.location = `mailto:abc@gmail.com?subject=Document&body= Here is the link to download document - ${encodeURIComponent(
          downloadURL
        )}`;
      }
    };
  };

  return (
    <React.Fragment>
      <TableRow className="documents-row" key={row?._id}>

        {/* <TableCell /> */}
        {/* {filters?.status == undefined ? (
          <TableCell className="main-check" padding="checkbox">
            <MyCheckbox
              name={"visible"}
              // handlechange={(e) => onCheckboxChange()}
              // checked={check.includes(row?._id)}
            />
          </TableCell>
        ) : null} */}
          <TableCell className="main-check" padding="checkbox">
            <div
              style={{ 
                opacity: checkAll ? 0.5 : 1,
              }}
            >
              <MyCheckbox
                name={"bulk-share"}
                handlechange={(e) => onCheckboxChange(e,row)}
                checked={checkAll ? true : check.some(obj => obj.id === row?._id)}
                disabled={checkAll}
              />
            </div>
          </TableCell>

        {filters?.status !== undefined ? (
          <>
            <TableCell component="th" scope="row" className="name-cell">
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <div className="transaction-account-name ellipsDueAmount">
                  {row.name}
                </div>
                <a
                  href={`/member-details/${row?.account_details?._id ?? row?.account_details?.id ?? row?.account_id}`}
                  target="_blank"
                  rel="noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  style={{ display: "flex", alignItems: "center", color: "#2555EF", flexShrink: 0 }}
                >
                  <OpenInNewOutlinedIcon style={{ fontSize: 10, width: 18, height: 18 }} />
                </a>
              </div>
            </TableCell>
            <TableCell align="left" className="type-cell">
              <div className="deocuments-led-sub d-flex justify-content-center">
                <div>
                  <div className="sub">
                    {row.type == "tax_statement"
                      ? "Statement"
                      : row.type == "tax_report"
                      ? "tax report"
                      : row.type}
                  </div>
                </div>
                {row.charger ? <div className="led">{row.charger}</div> : ""}
              </div>
            </TableCell>
          </>
        ) : (
          <>
            <TableCell align="left" className="type-cell">
              <div className="deocuments-led-sub ">
                <div>
                  <div className="sub">
                    {row.type == "tax_statement"
                      ? "Statement"
                      : row.type == "tax_report"
                      ? "tax report"
                      : row.type}
                  </div>
                </div>
                {row.charger ? <div className="led">{row.charger}</div> : ""}
              </div>
            </TableCell>
            <TableCell component="th" scope="row" className="name-cell">
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <div className="transaction-account-name ellipsDueAmount">
                  {row.name}
                </div>
                <a
                  href={`/member-details/${row?.account_details?._id ?? row?.account_details?.id ?? row?.account_id}`}
                  target="_blank"
                  rel="noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  style={{ display: "flex", alignItems: "center", color: "#2555EF", flexShrink: 0 }}
                >
                  <OpenInNewOutlinedIcon style={{ fontSize: 10, width: 18, height: 18 }} />
                </a>
              </div>
            </TableCell>
          </>
        )}
        {filters?.status?.toLowerCase() === "statements" && (
          <TableCell align="center">
            {numberFormat({number:+totalAmount, decimal:2, style: "currency"})}
          </TableCell>
        )}
        <TableCell
          align="center"
          onClick={() => {
            // setDrawerData(row);
            // setOpenModal(true);
          }}
        >
          <div className="transaction-led-sub table-row">
            <p className="sub">
              {formatDate({date:row?.date.start, formatType: "defaultWithUTC"})} -
              {row?.updatedAt
                ? row?.date.end !== null
                  ? formatDate({date:row?.date.end, formatType: "defaultWithUTC"})
                  :formatDate({date:row?.date.start, formatType: "defaultWithUTC"})
                : ""}
            </p>
          </div>
        </TableCell>

        <TableCell align="center">
          <div className="transaction-led-sub table-row">
            <p className="sub">
              {row?.createdAt ? formatDate({ date: row?.createdAt, formatType: "defaultWithUTC" }) : "-"}
            </p>
          </div>
        </TableCell>

        <TableCell align="left">
          <div className="deocuments-led-sub d-flex justify-content-center">
            <div>
              <div className="sub">
                {row?.lastSent
                  ? formatDate({date:row?.lastSent, formatType: "defaultWithTimeUTC"})
                  : ""}
              </div>
            </div>
          </div>
        </TableCell>
                    
        <TableCell  className="sticky-body-column" align="right">
          
          <Stack
            direction="row"
            spacing={0}
            className="d-flex justify-content-end"
            style={{ minHeight: "51px" }}
          >
            {!check.length && (
              <>
                {(row?.type === "tax_statement" || row?.type === "tax_report") && (
                  <IconButton size="large" onClick={() => {
                    deleteDocumentHandler(row._id)
                  }}>
                    <img src={deleteImg} alt="trush" width={26} />
                  </IconButton>
                )}
                <IconButton size="large" onClick={() => {
                    viewDocumentHandler(row._id)
                }}>
                  <img src={eyeImg} alt="eye" />
                </IconButton>
                
                <IconButton size="large" onClick={() => {
                  downloadFileHandler(row)
                }}>
                  <img src={downloadImg} alt="download" />
                </IconButton>
                
                <IconButton size="large" onClick={() => {
                  documentHandler(row)
                }}>
                  <img src={shareImg} alt="share" />
                </IconButton>
            </>
            )}

          </Stack>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default memo(DocumentsData);
